// "This week" gate (docs/HOME-2026-10.md, F6). The only home card code in the main bundle: it
// decides whether to load the card, then waits for load + idle with the start screen showing
// and imports the lazy chunk (its own JS + CSS, never precached). Nothing is requested before
// load, and nothing at all when the card is off, onboarding is live or this is a /?play= link.
// Turning the card back on in Settings brings it back without a reload.

// Pure: may the card load on this visit? get = the settings getter.
export function homeAllowed(ok, get) { return !!ok && get("homeWeek") !== false; }

let runs = 0, styled = null;

// ok: onboarding is not live and this is not a /?play= link. ctx: what the chunk needs (see main.js).
export function initHome(ok, ctx) {
	const root = document.documentElement, run = ++runs;
	let on = homeAllowed(ok, ctx.get);
	const off = ctx.subscribe(() => {
		const now = homeAllowed(ok, ctx.get);
		if (now && !on) { off(); delete root.dataset.week; initHome(ok, ctx); }
		on = now;
	});
	if (!homeAllowed(ok, ctx.get)) { delete root.dataset.home; root.dataset.week = "off"; return; } // free the reserved room
	let started = false;
	const go = () => {
		if (started || run !== runs || !homeAllowed(ok, ctx.get) || !ctx.isStartVisible()) return;
		started = true;
		mo.disconnect();
		if (!styled) {
			const css = document.createElement("link");
			css.rel = "stylesheet"; css.href = __RVM.homeCss;
			styled = new Promise((done) => { css.onload = css.onerror = done; }); // drawn unstyled, the card would spill out of the strip
			document.head.appendChild(css);
		}
		import(__RVM.homeJs).then((m) => styled.then(() => m.start(ctx))).catch(() => { delete root.dataset.home; root.dataset.week = "off"; });
	};
	// The start screen may come back later (a new tab); load then.
	const mo = new MutationObserver(() => { if (ready) go(); });
	let ready = false;
	const onLoad = () => {
		const idle = () => { ready = true; mo.observe(ctx.startEl, { attributes: true, attributeFilter: ["hidden"] }); go(); };
		if (window.requestIdleCallback) requestIdleCallback(idle, { timeout: 4000 }); else setTimeout(idle, 200);
	};
	if (document.readyState === "complete") onLoad(); else addEventListener("load", onLoad, { once: true });
}
